// removed by extract-text-webpack-plugin
module.exports = {"tabsContainer":"TabbedView__tabsContainer___H_b3U","tabsComponent":"TabbedView__tabsComponent___2hW61","navigation":"TabbedView__navigation___3gWgh","pointer":"TabbedView__pointer___3T0FV","label":"TabbedView__label___1Lxxt","tab":"TabbedView__tab___3cOw5","activeTab":"TabbedView__activeTab___2oGlK","activeTabCampaign":"TabbedView__activeTabCampaign___1IZKh TabbedView__activeTab___2oGlK","tabStyling":"TabbedView__tabStyling___2yrFR","tabStylingCampaign":"TabbedView__tabStylingCampaign___2YvSR TabbedView__activeTab___2oGlK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TabbedView/TabbedView.css
// module id = 1024
// module chunks = 0